// Module
var code = "<h2 id=\"mail-and-fax\">Mail and Fax</h2> <p>View a list of our addresses for payments, disputes, and letters.</p> ";
// Exports
export default code;